export default "https://cdn-static.gokick.com/assets/e388117c7865c86e8cffce5bc7abacefcd582b49/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";